import { PropsWithChildren } from "react";
import { Outlet } from "react-router-dom";

import { Layout, ValidAccountGuard } from "@/components/layout";
import { IntercomProvider } from "@/core/app/components/IntercomProvider";
import {
  NextAppGate,
  NextAppVisitTracker,
} from "@/core/app/components/NextAppRollout";

export const RootLayout = (props: PropsWithChildren) => {
  const { children = <Outlet /> } = props;

  return (
    <ValidAccountGuard>
      <NextAppGate />
      <NextAppVisitTracker />
      <Layout>
        <IntercomProvider />
        {children}
      </Layout>
    </ValidAccountGuard>
  );
};
